import React from "react";

export default function CornerFrame({ children, className = "" }) {
  return (
    <div className={`corners ${className}`}>
      <span className="corner-tr" />
      <span className="corner-bl" />
      {children}
    </div>
  );
}
